module.exports = __webpack_public_path__ + "img/ga.58f55c5c.png";